import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { UserRole, hasAnyUserRole } from "@/lib/userRoles";
import { DEFAULT_LANDING_PATH } from "@/lib/constants";

const RequireAuth = ({ allowedRoles }: { allowedRoles: string[]; }) => {
  const { user } = useAuth();
  const location = useLocation();

  const sessionSpecificDefaultUrl =
    user?.principalType === "Company"
      ? "/shop/reports/eod"
      : user?.principalType === "Provider"
        ? "/portal"
        : getDefaultPathForUserRole(user?.user?.role);

  return (
    // user?.principalType?.find((role: any) => allowedRoles?.includes(role))
    user?.accessToken ? ( //changed from user to accessToken to persist login after refresh
      allowedRoles.includes(user?.principalType) ? (
        <Outlet />
      ) : (
        <Navigate to={sessionSpecificDefaultUrl} replace />
      )
    ) : (
      <Navigate
        to={DEFAULT_LANDING_PATH || "/auth/login"}
        state={{ from: location }}
        replace
      />
    )
  );
};

// Función helper para obtener la ruta por defecto según el rol de usuario
const getDefaultPathForUserRole = (
  userRole: UserRole | number | null | undefined
): string => {
  switch (userRole) {
    case UserRole.REGIONAL_LEADER:
      return '/admin/itk-report';
    case UserRole.MASTER:
    case UserRole.PROGRAMMER:
    case UserRole.PARTNER:
    case UserRole.SELLER:
    default:
      return "/admin/companies";
  }
};

export default RequireAuth;
